import styled from 'styled-components'
import { customTheme } from '../../styles/theme'

interface IItemProps {
  $isMobile: boolean;
}

export const Wrapper = styled.div<IItemProps>`
  height: 100vh;
  background-color: #FFF;

  .container {
    overflow: auto;
    padding-bottom: 10vh;
    height:  ${({ $isMobile }) => $isMobile ? 'calc(100vh - 20vh)' : '100%'};
    ${({ $isMobile }) => !$isMobile && (
      `
        width: 60%;
        margin: 0 auto;
      `
    )}
  }
`

export const ContainerItem = styled.div`
  display: flex;
  margin: 0 auto;
  margin-top: 50px;
  justify-content: center;
  align-items: center;

  svg {
    margin-right: 5px;
  }
`
export const Title = styled.h3`
  font-size: ${customTheme.fontSizes.md};
`

export const ContainerForm = styled.div`
  margin: 0 4%;
  padding-top: 70px;

  button {
    width: 100%;
    border-radius: 50px;
    cursor: pointer;
    background: rgb(90,255,90);
    background: linear-gradient(180deg, rgba(90,255,90,1) 40%, rgba(112,238,112,1) 76%, rgba(82,200,82,1) 100%);
    font-size: 15px;
    font-weight: bold;
    margin-top: 20px;
    border: 2px solid #000;
    padding: 10px 0;
  }
`
